var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-contact-list',{attrs:{"object":Number(_vm.$route.params.id),"object-type":_vm.OBJECT_TYPE_PROPERTY,"c-permission-v":_vm.C_PROPERTY_CONTACTS_V,"c-permission-e":_vm.C_PROPERTY_CONTACTS_E}})}
var staticRenderFns = []

export { render, staticRenderFns }